<script>
import { Form, Field, Toast, Dialog } from 'vant'
import ImageUploader from '@/components/org/ImageUploader'
import PickerSelector from '@/components/org/PickerSelector'
import BottomToolbar from '@/components/org/BottomToolbar'
import Referee from '@/tbs/model/vo/Referee'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-referee-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-form': Form,
        'van-field': Field,
        'image-uploader': ImageUploader,
        'picker-selector': PickerSelector,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            referee: {
                id: null,
                organizationId: null,
                matchId: null,
                name: null,
                avatarUrl: null,
                avatar: null,
                phone: null,
                grade: null,
                gradeIndex: null,
            },
            isEdit: null,
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        gradeOptions() {
            return (new Referee).gradeOptions()
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onSubmitBtnClick() {
            console.log('onSubmitBtnClick')
            if (!this.validateSubmitRequired()) {
                // disable to submit and toast the message
                if (!this.referee.name) {
                    Toast(this.locale['referee-name-required'])
                }
            }
            else {
                // enable to submit
                this.submitData()
            }
        },
        onDeleteBtnClick() {
            console.log('onDeleteBtnClick')
            Dialog.confirm({
                title: this.locale['delete-referee'],
                message: this.locale['delete-referee-confirm-message']
            }).then(() => {
                // on confirm
                this.$emit('custom-event', {
                    type: 'delete',
                    data: this.referee
                })
            }).catch(() => {
                // on cancel
            })
        },
        onAvatarUploaderDataChange(data) {
            console.log('onAvatarUploaderDataChange', this.isEdit, data)
            this.referee.avatarUrl = null
            this.referee.avatar = data
        },
        onGradeDataChange(data) {
            console.log('onGradeDataChange', data.value)
            this.referee.grade = data.value
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        validateSubmitRequired() {
            // console.log('validateSubmitRequired')
            if (this.referee.name) {
                return true
            }
            else {
                return false
            }
        },
        submitData() {
            if (this.validateSubmitRequired()) {
                this.$emit('custom-event', {
                    type: 'save',
                    data: this.referee
                })
            }
        }
    },
}
</script>

<template>
    <div class="referee-edit">
        <van-form>
            <van-field 
                name="referee-name" 
                v-model="referee.name" 
                :label="locale['referee-name-label']" 
                :placeholder="locale['referee-name-placeholder']"
                :autofocus="!isEdit"
                clearable
                input-align="right"
                maxlength="30" 
            />
            <image-uploader
                :label="locale['referee-avatar-label']"
                :description="locale['referee-avatar-placeholder']"
                :oversizeMax="5000*1024"
                :oversizeHint="locale['upload-image-oversize']"
                :imageUrl="adjustImageSize(this.referee.avatarUrl, 400, 400)"
                @change-data="onAvatarUploaderDataChange"
            />
            <van-field 
                name="referee-phone" 
                v-model="referee.phone" 
                :label="locale['referee-phone-label']"
                clearable
                input-align="right"
                type="digit"
                maxlength="11" 
            />
            <picker-selector
                :label="locale['referee-grade-label']"
                :options="gradeOptions"
                :value="referee.grade"
                :index="referee.gradeIndex"
                @change-data="onGradeDataChange"
            />
        </van-form>
        <bottom-toolbar 
            v-if="!isEdit"
            type="button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            @click-main-button="onSubmitBtnClick"
        />
        <bottom-toolbar 
            v-else
            type="button-button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            :minorButtonLabel="locale['delete']"
            @click-main-button="onSubmitBtnClick"
            @click-minor-button="onDeleteBtnClick"
        />
    </div>
</template>